module.exports = __webpack_public_path__ + "img/multiplier2_normal.faa36511.png";